import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import config from '../../../config'
import {
  buildPaymentPlan,
  normalizeFlat,
  formatINR,
  formatDate,
  daysUntil
} from '../../../features/payments/dummyPayments'

const DISMISS_KEY = 'bl-payment-alert-dismissed'

// Banner reminding a member about an overdue / upcoming extra-flat payment.
// Pass `flat` when the caller already has it; otherwise it loads /flat-details.
const PaymentDueAlert = ({ flat: flatProp, showLink = true }) => {
  const [flat, setFlat] = useState(flatProp || null)
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === '1'
    } catch (e) {
      return false
    }
  })

  useEffect(() => {
    if (flatProp) {
      setFlat(flatProp)
      return
    }
    let cancelled = false
    axios
      .get(`${config.apiUrl}/flat-details`, { headers: { Authorization: localStorage.getItem('token') } })
      .then(res => { if (!cancelled) setFlat(normalizeFlat(res.data?.data)) })
      .catch(() => {}) // no flat (e.g. admin) — no alert
    return () => { cancelled = true }
  }, [flatProp])

  const plan = flat ? buildPaymentPlan(flat) : null
  const due = plan?.nextDue
  if (!due || (dismissed && showLink)) return null

  const days = daysUntil(due.dueDate)
  const overdue = due.status === 'overdue'

  const dismiss = () => {
    setDismissed(true)
    try { sessionStorage.setItem(DISMISS_KEY, '1') } catch (e) {}
  }

  return (
    <div className={`bl-alert ${overdue ? 'bl-alert--danger' : 'bl-alert--warning'}`} role="alert">
      <div className="bl-alert__icon" aria-hidden="true">
        <ion-icon name={overdue ? 'alert-circle-outline' : 'calendar-outline'}></ion-icon>
      </div>
      <div className="bl-alert__body">
        <strong>
          {overdue
            ? `Payment overdue by ${Math.abs(days)} ${Math.abs(days) === 1 ? 'day' : 'days'}`
            : days === 0
              ? 'Payment due today'
              : `Payment due in ${days} ${days === 1 ? 'day' : 'days'}`}
        </strong>
        <span>
          {formatINR(due.amount)} for “{due.label}” {overdue ? 'was' : 'is'} due on {formatDate(due.dueDate)}.
          {' '}Upload your receipt once paid.
        </span>
        {showLink && (
          <Link to="/payment-details" className="bl-alert__link">
            View payment details
          </Link>
        )}
      </div>
      {showLink && (
        <button type="button" className="btn btn-icon btn-sm" onClick={dismiss} aria-label="Dismiss payment reminder">
          <ion-icon name="close-outline" aria-hidden="true"></ion-icon>
        </button>
      )}
    </div>
  )
}

export default PaymentDueAlert
